import { createAsyncThunk } from '@reduxjs/toolkit';
import { login as loginAPI } from './queries';
// import * as queries from '../../../graphql/queries';

export const login = createAsyncThunk('auth/login', async (params) => {
  const { data } = await loginAPI(params);
  console.log('login data', data);
  return data;
});

